<template>
  <div data-private >
    <MicrosoftTeamsMeeting />
  </div>

</template>

<script>


import MicrosoftTeamsMeeting from '@/components/Lists/Teams_Meetings_Debug.vue'

export default {
  components: {MicrosoftTeamsMeeting},
  props:[],
  data() {
  },
  computed:{

  },
  methods:{
  },
  mounted() {
  },
}
</script>
